import classNames from 'classnames';

const PaginationItem = ({ className, disabled, active, onClick, text }) => {
  return (
    <div
      className={classNames(
        `select-none border-1 cursor-pointer flex items-center justify-center h-full rounded-[5px] border-[#D9A8E5] text-[18px] duration-75 font-[400] leading-[22px] transition-colors`,
        className,
        `${active ? 'bg-[#D9A8E5] text-white' : 'bg-white text-[#D9A8E5] '}`
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </div>
  );
};

export default PaginationItem;
